import { LanguageSwitcher } from '@/ui/components/language-switcher'
import { FeedbackSurvey } from '@/ui/components/feedback-survey/feedback-survey'
import UserSection from './user-section'

export const NavbarFooter = () => {
  return (
    <div className="relative mt-auto flex flex-col gap-2 p-4">
      <FeedbackSurvey />
      <footer className="flex items-center justify-between gap-2">
        <UserSection />
        <LanguageSwitcher />
      </footer>
    </div>
  )
}
